export const fieldType: any = {
  TEXT: 'text',
  CHECKBOX: 'checkbox',
};